import React from 'react';
import SuccessImage from '../../images/icons/success.svg';

export default class OrderSuccess extends React.Component {
  render() {
    return(
      <div className="order-success page-flyout checkout">
        <h2>Your Order was Submitted!</h2>
        <div className="image-wrapper"><img role="presentation" src={SuccessImage} /></div>
        <div className="note">Thank you for your purchase! We have received your order and will send a confirmation email within 24 hours.</div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/checkout/Success.js
 **/